import React from "react";
import GroupsListSkeleton from "@Components/groups/GroupsListSkeleton";

interface IProps {
    rowHeight?: number;
    count?: number;
}

export const SkeletonRows: React.FC<IProps> = ({rowHeight = 60, count = 5}: IProps) => {
    const renderRows = () => {
        const rows: JSX.Element[] = [];
        for (let i = 0; i < count; i++) {
            rows.push(<GroupsListSkeleton key={i} height={rowHeight} even={i % 2 === 0} />);
        }
        return rows;
    };
    
    return (
        <> {renderRows()} </>
    );
};